import Vue from 'vue';
import Vuex from 'vuex';

// Modules import downhere
import jStoreHome from './jStoreHome';
import jStoreLeave from './jStoreLeave';
import jStoreLogin from './jStoreLogin';
import jStoreLogout from './jStoreLogout';
import jStoreNotificationScreen from './jStoreNotificationScreen';
import jStoreSetting from './jStoreSetting';
import jStorePrivilege from './jStorePrivilege';
import jStorePrivilegePage from './jStorePrivilegePage';
import jStoreSecurityPage from './jStoreSecurityPage';
import jStoreApplication from './jStoreApplication';
import jStoreBoard from './jStoreBoard';
import jStoreAutomation from './jStoreAutomation';
import jStoreForm from './jStoreForm';
import jStoreFormUi from './jStoreFormUi';
import jStoreCanvas from './jStoreCanvas';
import jStoreDataConnectivity from './jStoreDataConnectivity';
import jStoreEmployee from './jStoreEmployee';
import jStorePosition from './jStorePosition';
import jStorePositionLayer from './jStorePositionLayer';
import jStoreOrganigram from './jStoreOrganigram';
import jStoreLayer from './jStoreLayer';
import jStoreDivisionFlow from './jStoreDivisionFlow';
import jStoreFlows from './jStoreFlows';
import jStoreRules from './jStoreRules';
import jStoreCompanyProfile from './jStoreCompanyProfile';
import jStoreLocation from './jStoreLocation';
import jStoreThirdParty from './jStoreThirdParty';
import jStoreAi from './jStoreAi';
import jStoreJoana from './jStoreJoana';
import jStoreExperienceManagerV2 from './jStoreExperienceManagerV2';
import jStoreMaintenanceMode from './jStoreMaintenanceMode';
import jStoreLoginActivity from './jStoreLoginActivity';

// Initialize vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    // Include imported modules in here
    jStoreHome,
    jStoreLeave,
    jStoreLogin,
    jStoreLogout,
    jStoreNotificationScreen,
    jStoreSetting,
    jStorePrivilege,
    jStorePrivilegePage,
    jStoreSecurityPage,
    jStoreApplication,
    jStoreBoard,
    jStoreAutomation,
    jStoreForm,
    jStoreFormUi,
    jStoreCanvas,
    jStoreDataConnectivity,
    jStoreEmployee,
    jStorePosition,
    jStorePositionLayer,
    jStoreOrganigram,
    jStoreLayer,
    jStoreDivisionFlow,
    jStoreFlows,
    jStoreCompanyProfile,
    jStoreLocation,
    jStoreRules,
    jStoreThirdParty,
    jStoreAi,
    jStoreJoana,
    jStoreExperienceManagerV2,
    jStoreMaintenanceMode,
    jStoreLoginActivity,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/stores/index.js